import { render, staticRenderFns } from "./stationDetail.vue?vue&type=template&id=2db3af66&scoped=true"
import script from "./stationDetail.vue?vue&type=script&lang=js"
export * from "./stationDetail.vue?vue&type=script&lang=js"
import style0 from "./stationDetail.vue?vue&type=style&index=0&id=2db3af66&prod&lang=less&rel=stylesheet%2Fless&scoped=true"
import style1 from "./stationDetail.vue?vue&type=style&index=1&id=2db3af66&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db3af66",
  null
  
)

export default component.exports